import React from 'react';

const TextMarquee = ({ text }) => {
  // Pour les textes courts, affichage normal sans animation
  if (text.length < 25) {
    return <span className="text-sm sm:text-base font-medium text-gray-900 dark:text-white">{text}</span>;
  }
  
  // Pour les textes longs, animation de défilement infini
  return (
    <div className="relative overflow-hidden w-full">
      <div className="marquee-container">
        <div className="absolute top-0 bottom-0 left-0 w-[15px] z-[2] pointer-events-none bg-gradient-to-r from-white to-transparent dark:from-dark-800 dark:to-transparent"></div>
        <div className="marquee-content">
          <span className="text-sm sm:text-base font-medium text-gray-900 dark:text-white">{text}</span>
          <span className="text-sm sm:text-base font-medium text-gray-500 dark:text-gray-400 separator">•</span>
          <span className="text-sm sm:text-base font-medium text-gray-900 dark:text-white">{text}</span>
          <span className="text-sm sm:text-base font-medium text-gray-500 dark:text-gray-400 separator">•</span>
        </div>
        <div className="absolute top-0 bottom-0 right-0 w-[15px] z-[2] pointer-events-none bg-gradient-to-l from-white to-transparent dark:from-dark-800 dark:to-transparent"></div>
      </div>
    </div>
  );
};

export default TextMarquee; 